import {
  AppBar,
  Box,
  Button,
  Container,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import ReceiptLongRoundedIcon from "@mui/icons-material/ReceiptLongRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { RouteNames } from "../../navigation/RouteNames";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { logoutAdmin } from "../../store/slices/adminAuthSlice";
import { AppColors } from "../../constants/AppColors";

const navItems = [
  {
    label: "Accounts",
    to: RouteNames.accounts,
    icon: <DashboardRoundedIcon fontSize="small" />,
  },
  {
    label: "Activity logs",
    to: RouteNames.activityLogs,
    icon: <ReceiptLongRoundedIcon fontSize="small" />,
  },
];

export const AdminLayout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { user, loading } = useAppSelector((state) => state.adminAuth);

  const handleLogout = async () => {
    await dispatch(logoutAdmin());
    navigate(RouteNames.login);
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: "background.paper",
          color: "text.primary",
          borderBottom: "1px solid",
          borderColor: "divider",
        }}
      >
        <Toolbar>
          <Stack
            direction="row"
            spacing={1.5}
            sx={{
              alignItems: "center",
              flex: 1,
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "14px",
                bgcolor: AppColors.primary,
                color: AppColors.textOnPrimary,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 900,
              }}
            >
              RP
            </Box>

            <Box>
              <Typography
                sx={{
                  fontWeight: 900,
                  lineHeight: 1.1,
                }}
              >
                RentPilot Admin
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {user?.email || "Admin panel"}
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction="row"
            spacing={1}
            sx={{
              alignItems: "center",
            }}
          >
            {navItems.map((item) => (
              <Button
                key={item.to}
                component={NavLink}
                to={item.to}
                startIcon={item.icon}
                sx={{
                  color: "text.secondary",
                  "&.active": {
                    color: "primary.main",
                    bgcolor: "rgba(37, 99, 235, 0.08)",
                  },
                }}
              >
                {item.label}
              </Button>
            ))}

            <Button
              startIcon={<LogoutRoundedIcon fontSize="small" />}
              onClick={handleLogout}
              disabled={loading}
              color="error"
            >
              Logout
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>

      <Container maxWidth="xl" sx={{ py: 3 }}>
        <Outlet />
      </Container>
    </Box>
  );
};
